function OkPhotos() {
	return typeof window !== "undefined" && window.OkPhotos ? window.OkPhotos : {};
}

export default OkPhotos;



// WEBPACK FOOTER //
// ./src/shared/modules/OkPhotos.js